import React from 'react';
import Icon from 'components/AppIcon';

const POWER_UP_ICONS = {
  magnet: '🧲',
  shield: '🛡️',
  multiplier: '✖️',
  jetpack: '🚀',
  speedboost: '⚡',
};

export default function GameHUD({
  score,
  coins,
  distance,
  highScore,
  multiplier,
  activePowerUps,
  comboChain,
  environment,
  characterEmoji,
}) {
  const isNearRecord = highScore > 0 && score > 0 && score >= highScore * 0.8;

  return (
    <div className="absolute inset-x-0 top-0 z-20 pointer-events-none">
      {/* Top bar */}
      <div className="flex items-start justify-between p-3 gap-2">
        {/* Score */}
        <div className="flex flex-col gap-1">
          <div
            className="flex items-center gap-2 px-3 py-1.5 rounded-xl backdrop-blur-sm"
            style={{ background: 'rgba(0,0,0,0.6)', border: '1px solid rgba(255,255,255,0.15)' }}
          >
            <Icon name="Star" size={14} color="#f59e0b" />
            <span className="font-data text-sm font-bold text-white">{score?.toLocaleString()}</span>
          </div>
          {highScore > 0 && (
            <div
              className="flex items-center gap-1.5 px-2 py-1 rounded-lg"
              style={{ background: isNearRecord ? 'rgba(245,158,11,0.3)' : 'rgba(0,0,0,0.4)', border: isNearRecord ? '1px solid rgba(245,158,11,0.6)' : '1px solid rgba(255,255,255,0.1)' }}
            >
              <Icon name="Trophy" size={11} color={isNearRecord ? '#f59e0b' : '#9ca3af'} />
              <span className="font-data text-xs" style={{ color: isNearRecord ? '#f59e0b' : '#9ca3af' }}>
                {isNearRecord ? '🔥 Near Record!' : `Best: ${highScore?.toLocaleString()}`}
              </span>
            </div>
          )}
        </div>

        {/* Center - Environment name */}
        <div
          className="px-3 py-1.5 rounded-xl backdrop-blur-sm"
          style={{ background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.1)' }}
        >
          <span className="font-caption text-xs text-white opacity-80">{environment}</span>
        </div>

        {/* Coins + Distance */}
        <div className="flex flex-col gap-1 items-end">
          <div
            className="flex items-center gap-2 px-3 py-1.5 rounded-xl backdrop-blur-sm"
            style={{ background: 'rgba(0,0,0,0.6)', border: '1px solid rgba(255,255,255,0.15)' }}
          >
            <span className="text-sm">🪙</span>
            <span className="font-data text-sm font-bold text-white">{coins}</span>
            {multiplier > 1 && (
              <span className="text-xs font-bold" style={{ color: '#FFD700' }}>×{multiplier}</span>
            )}
          </div>
          <div
            className="flex items-center gap-1.5 px-2 py-1 rounded-lg"
            style={{ background: 'rgba(0,0,0,0.4)', border: '1px solid rgba(255,255,255,0.1)' }}
          >
            <Icon name="MapPin" size={11} color="#9ca3af" />
            <span className="font-data text-xs text-gray-300">{distance}m</span>
          </div>
        </div>
      </div>
      {/* Combo chain */}
      {comboChain >= 3 && (
        <div className="flex justify-center mt-1">
          <div
            className="px-4 py-1.5 rounded-full animate-bounce"
            style={{ background: 'rgba(245,158,11,0.8)', border: '2px solid #f59e0b' }}
          >
            <span className="font-bold text-white text-sm">🔥 {comboChain}x COMBO!</span>
          </div>
        </div>
      )}
      {/* Active power-ups */}
      {Object.keys(activePowerUps)?.length > 0 && (
        <div className="flex justify-center gap-2 mt-2">
          {Object.entries(activePowerUps)?.map(([puId, expiry]) => {
            const remaining = Math.max(0, Math.ceil((expiry - Date.now()) / 1000));
            return (
              <div
                key={puId}
                className="flex items-center gap-1.5 px-3 py-1 rounded-full"
                style={{ background: 'rgba(0,0,0,0.7)', border: '1px solid rgba(255,255,255,0.3)' }}
              >
                <span className="text-sm">{POWER_UP_ICONS?.[puId] || '⚡'}</span>
                <span className="font-data text-xs text-white">{remaining}s</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
